import '../components/PlatformIntegrations/platform-integrations.css'

import Header from "../components/PlatformIntegrations/Header"


import TransitionPage from '../utils/TransitionPage';
import ChooseIndustry from '../components/PlatformIntegrations/ChooseIndustry';
import Technologies from '../components/PlatformIntegrations/Technologies';

import { Helmet } from 'react-helmet-async';

const PlatformIntegrations = () => {
  return (
    <>
      <Helmet>
          <title>Platform Integrations | Advante Digital</title>
          <meta name="description" content="We connect the APIs, portals, dashboards, payment flows, and internal tools your existing platforms depend on using AI-assisted engineering, human review, staging, QA, and controlled deployment."/>
          <meta name='keywords' content='platform integrations, API integrations, internal tools, payment integrations, admin systems, staging, QA, controlled deployment'/>
      </Helmet>
      <Header />
      <Technologies />
      <ChooseIndustry />
    </>
  );
}

export default TransitionPage(PlatformIntegrations ); 